<div class="reports-container">
  <div class="page-header">
    <h2 class="title">判定結果一覧（分析レポート）</h2>
    <p class="subtitle">抽出された物件のボリューム算定および収支シミュレーション結果を一覧表示します。</p>
  </div>

  <mat-card class="table-card shadow-sm">
    <div class="table-header-actions">
      <mat-form-field appearance="outline" class="filter-field">
        <mat-label>結果を絞り込む</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="例: SUUMO, 合格" #input>
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
      
      <button mat-stroked-button color="primary">
        <mat-icon>download</mat-icon> CSVダウンロード
      </button>
    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort class="full-width-table">

        <ng-container matColumnDef="source">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> サイト </th>
          <td mat-cell *matCellDef="let row"> 
            <span class="source-badge">{{row.source}}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="address">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> 所在地 </th>
          <td mat-cell *matCellDef="let row"> {{row.address}} </td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> 価格 </th>
          <td mat-cell *matCellDef="let row"> <b>{{row.price}}</b> 万円 </td>
        </ng-container>

        <ng-container matColumnDef="area">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> 土地面積 </th>
          <td mat-cell *matCellDef="let row"> {{row.area}} ㎡ </td>
        </ng-container>

        <ng-container matColumnDef="frontage">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> 間口 </th>
          <td mat-cell *matCellDef="let row"> {{row.frontage}} m </td>
        </ng-container>

        <ng-container matColumnDef="estimatedRooms">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> 想定部屋数 </th>
          <td mat-cell *matCellDef="let row"> 
            <span class="highlight-val">{{row.estimatedRooms}}</span> 部屋 
          </td>
        </ng-container>

        <ng-container matColumnDef="estimatedYield">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> 想定利回り </th>
          <td mat-cell *matCellDef="let row" [ngClass]="{'high-yield': row.estimatedYield >= 7}"> 
            <b>{{row.estimatedYield}}</b> % 
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> 判定 </th>
          <td mat-cell *matCellDef="let row"> 
            <span class="status-chip" [ngClass]="{
              'status-pass': row.status === '合格',
              'status-warn': row.status === '要確認',
              'status-fail': row.status === '見送り'
            }">
              {{row.status}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> 詳細 </th>
          <td mat-cell *matCellDef="let row">
            <a mat-icon-button color="primary" href="#" target="_blank" matTooltip="元サイトを開く">
              <mat-icon>open_in_new</mat-icon>
            </a>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell empty-cell" colspan="9">データが見つかりません: "{{input.value}}"</td>
        </tr>
      </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="ページを選択"></mat-paginator>
  </mat-card>
</div>